// extracted by mini-css-extract-plugin
export default {"locale-select":"dq1vA","locale-text":"YoeN+"};